const user = {
  state: {
    LoginShowOrNot: true, // 是否登录的判断
  },
  mutations: {
  },
  actions: {
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/DataStorage.js